export default __webpack_public_path__ + "static/media/poster_2022_2.3af382cd.svg";